import { Box, Card, CardActionArea, IconButton } from '@material-ui/core'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import * as React from 'react'

import Typography from '../base/Typography'
import Icons from '../icons/Icons'

export interface DocumentInterface {
  id: number
  name: string
  date: string
  author: string
}

export type StyledDocCard = {
  author: DocumentInterface
  onClick(docId: number): void
  onDelete(id: number): void
  mandatory?: boolean
  hideIdAuthor?: boolean
  hideDeleteBtn?: boolean
}

export type CardDocProps = StyledDocCard

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      background: '#EDF1F4',
      width: 237,
      borderRadius: 4,
      border: '1px solid #EDF1F4',
      position: 'relative'
    },
    deleteIcon: {
      display: 'flex',
      justifyContent: 'flex-end',
      right: 0,
      position: 'absolute',
      zIndex: 2,
      color: '#32607A'
    },
    cardIconDoc: {
      padding: theme.spacing(2),
      background: theme.palette.common.white,
      borderRadius: 50,
      marginTop: theme.spacing(5),
      marginBottom: theme.spacing(5),
      filter: 'drop-shadow(0px 3px 6px rgba(0, 0, 0, 0.03))',
      color: theme.palette.primary.main
    },
    hideElement: {
      display: 'none'
    }
  })
)

const DocumentCard: React.FC<CardDocProps> = (props) => {
  const {
    author,
    hideIdAuthor,
    mandatory,
    onClick,
    onDelete,
    hideDeleteBtn
  } = props
  const classes = useStyles()
  return (
    <Card classes={{ root: classes.root }} elevation={0}>
      {hideDeleteBtn && (
        <Box className={classes.deleteIcon}>
          <IconButton
            size="medium"
            onClick={() => (author ? onDelete(author.id) : '')}
          >
            <Icons size="small" iconName="TrashIcon" />
          </IconButton>
        </Box>
      )}
      <CardActionArea onClick={() => (author ? onClick(author.id) : '')}>
        <Box display="flex" justifyContent="center" alignItems="center">
          <Box className={classes.cardIconDoc}>
            <Icons
              size="medium"
              iconName={mandatory ? 'PlusIcon' : 'DocumentIcon'}
            />
          </Box>
        </Box>
        <Box bgcolor="#fff" padding={1}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography
              noWrap
              children={`${author ? author.name : 'Doc Name'} ${
                mandatory ? '(Mandatory)' : ''
              }`}
              variant="subtitle2"
            />
            <Typography
              className={hideIdAuthor ? classes.hideElement : ''}
              children={`#${author ? author.id : 'ID'}`}
              variant="caption"
            />
          </Box>
          <Box
            marginTop={1}
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography
              children={`Date: ${author ? author.date : 'Missing'}`}
              variant="caption"
            />
            <Typography
              className={hideIdAuthor ? classes.hideElement : ''}
              children={`By - ${author ? author.author : 'Anonym'}`}
              variant="caption"
            />
          </Box>
        </Box>
      </CardActionArea>
    </Card>
  )
}

export default DocumentCard
